/**
 * Hook de datos del **historial paginado** (`GET /api/v1/talonarios/history`).
 *
 * Datos de servidor -> TanStack Query. La query key incluye la sede activa y los
 * filtros (trabajador/acción/página) para cachear por combinación. La red la
 * gobierna `lib/api`. `placeholderData: keepPreviousData` evita el parpadeo a
 * vacío al paginar o filtrar.
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchTalonarioHistory } from "../api";
import type { TalonarioHistoryPage, TalonarioHistoryQuery } from "../types";
import { talonarioHistoryQueryKey } from "./queryKeys";

export function useTalonarioHistory(query: TalonarioHistoryQuery) {
  const sedeId = getActiveSedeId();
  return useQuery<TalonarioHistoryPage>({
    queryKey: talonarioHistoryQueryKey(sedeId, query),
    queryFn: () => fetchTalonarioHistory(query),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  });
}
